import React, { useState, useEffect, useContext } from "react";
//
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { StoreContext } from "../../../store/StoreProvider";
import fireAuth from "../../../api/firebase/auth/utils";
import useLocaleRoute from "../../../common/hooks/useLocaleRoute";
import urls from "../../../api/project/ApiUrls";
import { ROUTE_PATH } from "../../../config/CONSTANTS";
import { setCommonDialogContext } from "../../../reduxStore/commonSlice";

const useGotoLogin = () => {
  // route,intl
  const navigate = useNavigate();
  const intl = useIntl();
  // props
  // store
  const [state] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;
  // redux
  const reduxDispatch = useDispatch();
  // local state
  const isLoggedIn = fireAuth.isLoggedIn(user);

  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );

  useEffect(() => {
    // 當登入狀態,一律進入 sna page
    if (!isLoggedIn) {
      reduxDispatch(
        setCommonDialogContext({
          openSignal: Date.now(),
          title: intl.formatMessage({
            id: "console.login.first",
            defaultMessage: "請先登入再使用本系統功能",
          }),
          contentText: [`點擊「好」，跳轉至登入頁面`],
          yesText: "好",
          withFinishIcon: true,
          onYes: () => {
            // redirect to sna page
            navigate(handleLocaleRoute(ROUTE_PATH.LogIn));
          },
        })
      );
    }
  }, []);

  return isLoggedIn;
};

export default useGotoLogin;
